import { render, staticRenderFns } from "./CustomerCustomerAccess.vue?vue&type=template&id=5d1a682d"
import script from "./CustomerCustomerAccess.vue?vue&type=script&lang=js"
export * from "./CustomerCustomerAccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports